<template>
    <div class="container-fluid">
        <div v-if="errors && errors.length > 0" class="alert alert-danger">
            {{ getErrorsText }}
        </div>
        <h4 class="mb-5 mr-5">Добавление тематической подборки</h4>
        <el-form ref="form" :model="form" label-position="left" label-width="180px" id="uploadForm" name="uploadForm"
                 enctype="multipart/form-data">
            <el-form-item label="Название">
                <el-input v-model="form.title"></el-input>
            </el-form-item>
            <el-form-item label="Сортировка">
                <el-input v-model="form.sort"></el-input>
            </el-form-item>
            <el-form-item label="Активность">
                <el-checkbox v-model="form.activity"></el-checkbox>
            </el-form-item>
            <el-form-item label="Изображение">
                <el-upload
                action=""
                list-type="picture"
                :limit="1"
                :auto-upload="false"
                :on-change="handleChange"
                >
                <el-button size="small" type="primary">Добавить Изображение</el-button>
                </el-upload>
            </el-form-item>
            <el-form-item label="Выбрать продукты">
              <el-button size="small" type="primary" @click="showProducts()">Выбрать</el-button>
              <el-tag checked v-if="form.productIds.length > 0">Выбрано: {{form.productIds.length}}</el-tag>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="storeSelection()">Добавить</el-button>
                <el-button @click="back()">Отмена</el-button>
            </el-form-item>
        </el-form>
        <select-products
        v-if="$store.getters.showProductsDialog"
        :selected-products="products"
        @updateParent="onUpdateSalary" 
        />
    </div>
</template>

<script>
import axios from "axios";
import getErrors, { getTextErrors } from '../../composable/utils/getErrors';
import useFormData from '../../composable/useFormData'
import SelectProducts from "@/components/Products/SelectProducts";

export default {
    components: {SelectProducts},
    data() {
      return {
        form: {
          title: '',
          image: '',
          sort: 0,
          productIds: [],
          activity: true,
        },
        products: [],
        errors: [],
        file: '',
        showPreview: false,
        imagePreview: '',
      }
    },
    computed: {
      getErrorsText() {
        if (this.errors && this.errors.length > 0) {
          return getTextErrors(this.errors)
        }
        return ''
      }
    },
    methods: {
      onUpdateSalary(value) {
        this.products = value || [];
        this.form.productIds = this.products.map((e) => e.id)
      },
      back() {
          this.$router.push('/selections');
      },
      showProducts() {
          this.$store.commit('showProductsDialog', true);
      },
      handleChange(v){
        this.form.image = v?.raw || undefined
      },
      storeSelection() {
        const { execute } = useFormData()

        const data = execute().setFields([
          'image',
          'title',
          'activity',
          'sort',
          'productIds',
        ]).getFormData(this.form)

          axios.post('/selection', data).then(() => {
            this.$router.push('/selections');
          }).catch((errors) => {
              this.errors = errors.response.data.errors;
              if (errors.response.status === 401) {
                  this.$router.push('/login');
              }
              if(errors.response.status === 422) {
                this.setErrors(errors.response.data.errors)
              }
          });
      },

      setErrors(err) {
        this.errors = getErrors(err)
      }

    }
}
</script>

<style scoped>

</style>